import { requestTimeout, handleResponse } from "../utils";
// import { Cookies } from 'react-cookie'

const apiUrl = process.env.REACT_APP_API_URL;
const apiMaxTime = process.env.REACT_APP_API_EXEC_TIME;

/**
 * Mark an enrollment as complete.
 * @param {string|number} enrollmentId - The enrollment ID to mark as complete.
 * @returns {Promise<any>}
 */
const _setEnrollmentComplete = (enrollmentId) => {
  const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE);
  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };
  return requestTimeout(
    fetch(`${apiUrl}enrollments/${enrollmentId}/complete`, requestOptions)
  ).then(handleResponse).catch(console.error);
};

/**
 * NOTE: The backend does NOT support GET /api/enrollments/:id.
 * If you need enrollment status, ask your backend team for the correct endpoint.
 * The following function is commented out to avoid 404 errors.
 */
// const _getEnrollmentStatus = (enrollmentId) => {
//   const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE);
//   const requestOptions = {
//     method: "GET",
//     credentials: "include",
//     headers: {
//       Authorization: "Bearer " + token,
//       "Content-Type": "application/json",
//       Accept: "application/json",
//     },
//   };
//   return requestTimeout(
//     fetch(`${apiUrl}enrollments/${enrollmentId}`, requestOptions)
//   ).then(handleResponse);
// };

const _getCourseDetails = (courseId) =>
  requestTimeout(
    fetch(`${apiUrl}courses/${courseId}`, {
      method: "GET",
      credentials: "include",
    })
  ).then(handleResponse);

const _setTopicComplete = (topicId) =>
  requestTimeout(
    fetch(`${apiUrl}topics/${topicId}/complete`, {
      method: "POST",
      credentials: "include",
    })
  ).then(handleResponse);

export const courseApi = {
  _all,
  _get,
  _featured,
  _buy_course,
  _my_courses,
  _get_details,
  _storeMultipleAnswers,
  _downloadCertificate,
  _checkCourseCompletion,
  _getUserCoursesWithProgress,
  _buy_course_free,
  _fetchCourseFlags,
  _updateCourseFlags,
  _setEnrollmentComplete,
  // _getEnrollmentStatus, // REMOVED: No such endpoint in backend
  _getCourseDetails,
  _setTopicComplete,
};

async function _all() {
  const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE);
  const requestOptions = {
    method: "GET",
    credentials: "include",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };
  return requestTimeout(apiMaxTime, fetch(apiUrl + "courses", requestOptions))
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

async function _get(slug, userId) {
  let token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE);

  const requestOptions = {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({ userId }),
  };

  let result = await requestTimeout(
    apiMaxTime,
    fetch(apiUrl + "get-courses/" + slug, requestOptions)
  )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
  return result;
}

async function _featured() {
  const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE);

  const requestOptions = {
    method: "GET",
    credentials: "include",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };
  return requestTimeout(
    apiMaxTime,
    fetch(apiUrl + "courses/featured", requestOptions)
  )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

async function _buy_course(form_data) {
  const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE);
  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(form_data),
  };
  return requestTimeout(
    apiMaxTime,
    fetch(apiUrl + "courses/purchase", requestOptions)
  )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

async function _buy_course_free(course_id) {
  const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE);
  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };
  return requestTimeout(
    apiMaxTime,
    fetch(apiUrl + "courses/purchase/" + course_id, requestOptions)
  )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

async function _my_courses() {
  const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE);
  const requestOptions = {
    method: "GET",
    credentials: "include",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };
  return requestTimeout(
    apiMaxTime,
    fetch(apiUrl + "account/courses", requestOptions)
  )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

async function _get_details(slug) {
  const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE);
  const requestOptions = {
    method: "GET",
    credentials: "include",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };
  return requestTimeout(
    apiMaxTime,
    fetch(apiUrl + "account/courses/" + slug, requestOptions)
  )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

async function _storeMultipleAnswers(data) {
  const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE);
  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(data),
  };

  return requestTimeout(
    apiMaxTime,
    fetch(apiUrl + "user-answers/multiple", requestOptions)
  )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

async function _downloadCertificate(courseId) {
  const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE);
  const requestOptions = {
    method: "GET",
    credentials: "include",
    headers: {
      Authorization: "Bearer " + token,
      Accept: "application/pdf",
    },
  };

  return requestTimeout(
    apiMaxTime,
    fetch(apiUrl + `account/courses/${courseId}/certificate`, requestOptions)
  ).then((response) => {
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    return response.blob();
  });
}

async function _checkCourseCompletion(slug) {
  const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE);
  const requestOptions = {
    method: "GET",
    credentials: "include",
    headers: {
      Authorization: "Bearer " + token,
      Accept: "application/pdf",
    },
  };

  return requestTimeout(
    apiMaxTime,
    fetch(apiUrl + `account/courses/${slug}/check-completion`, requestOptions)
  )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

async function _getUserCoursesWithProgress() {
  const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE);
  const requestOptions = {
    method: "GET",
    credentials: "include",
    headers: {
      Authorization: "Bearer " + token,
      Accept: "application/pdf",
    },
  };

  return requestTimeout(
    apiMaxTime,
    fetch(apiUrl + `account/progress/get-progress`, requestOptions)
  )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

async function _fetchCourseFlags(courseId) {
  const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE);
  const requestOptions = {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };

  return requestTimeout(
    apiMaxTime,
    fetch(`${apiUrl}get-course-flags-by-id/course/${courseId}`, requestOptions)
  )
    .then(handleResponse)
    .then((response) => {
      // If response is an array of topics
      if (Array.isArray(response)) {
        return response.map(flag => ({
          ...flag,
          complete: Boolean(flag.complete),
        }));
      }
      // If response is an object with a topics array
      if (response && Array.isArray(response.topics)) {
        return {
          ...response,
          topics: response.topics.map(flag => ({
            ...flag,
            complete: Boolean(flag.complete),
          })),
        };
      }
      return response;
    });
}

async function _updateCourseFlags(flagId, flags) {
  const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE);
  const requestOptions = {
    method: "PUT",
    credentials: "include",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    }
  };
  // Only include body if flags is provided and not undefined/null
  if (flags !== undefined && flags !== null) {
    requestOptions.body = JSON.stringify(flags);
  }
  return requestTimeout(
    apiMaxTime,
    fetch(`${apiUrl}update-course-flags-by-id/course/${flagId}`, requestOptions)
  )
    .then(handleResponse)
    .then((response) => response);
}
export async function updateTopicCompletion(courseId, topicId, complete) {
  const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE);
  const requestOptions = {
    method: "PUT",
    credentials: "include",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({ complete: Boolean(complete) }),
  };
  return requestTimeout(
    apiMaxTime,
    fetch(`${apiUrl}courses/${courseId}/topics/${topicId}/completion`, requestOptions)
  ).then(handleResponse);
}